const e = o => o && "olx-".concat(o.replace("--", ""));
export { e as withColors };